<ng-container [ngSwitch]="field.FieldType">
    <!-- FieldType == 0 means AlphaNumeric -->
<tyl-form-field [label]="field.FieldName" *ngSwitchCase="0">
  <input #value0Ref matInput id="dtp{{field.FieldName}}"  type='text' [(ngModel)]='field.FieldValue'
      [maxlength]="fieldLengthString" />
</tyl-form-field>

<!-- Date -->
  <tyl-datepicker #value1Ref *ngSwitchCase="1" id="dtp{{field.FieldName}}" [label]="field.FieldName" [(value)]="field.FieldValue"
    [ngStyle]="{'width': field.FieldName.length > 12 ? (field.FieldName.length*12 + 'px') : '130px'}">
  </tyl-datepicker>
  <!-- FieldType == 2 means Numeric control -->
<tyl-form-field *ngSwitchCase="2"  [label]="field.FieldName">
  <input #value2Ref matInput id="dtp{{field.FieldName}}" [allowDecimal]="true"
   [(ngModel)]='field.FieldValue' [maxPrecision]="field.FieldDecimal" [minimumEnforce]="1" [maximumEnforce]="getLength(field.FieldLength)"/>
</tyl-form-field>
<!-- FieldType == 3 means Lookup -->
<tyl-form-field *ngSwitchCase="3" [label]="field.FieldName">
  <mat-select id='ddl{{field.FieldName}}' [(ngModel)]='field.FieldValueId'>
    <mat-option [value]="null"></mat-option>
    <mat-option *ngFor='let lk of field.FieldLookupValues' [value]='lk.Id'>
      <span style="color: black !important;">{{lk.Code}} - {{lk.Description}}</span> </mat-option>
  </mat-select>
</tyl-form-field>
</ng-container>
